import React from 'react'
import loadingImg from '../../assets/heartanimation.svg'

const Loader = ({backgroundColor}) => {
  return (
    <div
    id="overlay"
    className="flex items-center h-[40vh] justify-center bg-opacity-50 z-[1000]"
    style={{ background: "" }}
    
  >
    <div className='loader rounded-full flex items-center justify-center z-50' style={{
      background:backgroundColor ?? "transparent"
    }}>
      <img src={loadingImg} alt='pumpingHeart' className='h-[60px] w-[60px]'/>
    </div>
  </div>
  )
}

export default Loader